import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { CompanySettings } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const COMPANY_SETTINGS_URL = `${SETTINGS_BASE_URL}/company/company`;

export class companySettingsRepository extends BaseRestRepository {
  public async changeCompanySettings(payload: Partial<CompanySettings>) {
    const url = COMPANY_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async getCompanySettings(): Promise<CompanySettings> {
    const url = COMPANY_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {}, false);
    return this.getJsonResponse(response);
  }
}

export const companySettingsRepo = new companySettingsRepository();
